export const FieldProps = {
    Props:[
        { id: 'name', maxLength: 50, mandatory: true },
        { id: 'surname', maxLength: 50, mandatory: false },
        { id: 'address', maxLength: 80, mandatory: true },
        { id: 'houseno', maxLength: 10, mandatory: false },
        { id: 'country', maxLength: 50, mandatory: true },
        { id: 'city', maxLength: 50, mandatory: true },
        { id: 'province', maxLength: 2, mandatory: true },
        { id: 'zip', maxLength: 5, mandatory: true },
        { id: 'nation', maxLength: 50, mandatory: true },
        { id: 'at', maxLength: 80, mandatory: false },
        { id: 'email', maxLength: 70, mandatory: false },
        { id: 'phone', maxLength: 30, mandatory: false },
        { id: 'number', maxLength: 30, mandatory: false },
        { id: 'note', maxLength: 70, mandatory: false },
    ],
   
    getFieldProp: function (fieldName,fieldProp) {
        let prop = this.Props.find(a => a.id == fieldName.toLowerCase());
        if (prop == undefined) {
            return null;
        } 
        if (fieldProp in prop) {
            return prop[fieldProp];
        }
            
        return '';
    }

};

export const WarehouseSingleOrderProps = {
    Props: [
        { id: 'number', maxLength: 50, mandatory: true },
        { id: 'businessName', maxLength: 255, mandatory: false },
        { id: 'name', maxLength: 50, mandatory: false },
        { id: 'address', maxLength: 255, mandatory: false },
        { id: 'city', maxLength: 50, mandatory: false },
        { id: 'zip', maxLength: 20, mandatory: false },
        { id: 'province', maxLength: 2, mandatory: true },
        { id: 'country', maxLength: 2, mandatory: false },
        { id: 'phone', maxLength: 20, mandatory: false },
        { id: 'mobile', maxLength: 20, mandatory: false },
        { id: 'fax', maxLength: 20, mandatory: false },
        { id: 'email', maxLength: 255, mandatory: false },
        { id: 'customerInternalReference', maxLength: 50, mandatory: false },
        { id: 'customerCode', maxLength: 50, mandatory: true },
        { id: 'customerPIVA', mandatory: false },
        { id: 'customerFiscalCode', mandatory: false },
        { id: 'customerUniqueCode', mandatory: false },
        { id: 'deliveryCode', maxLength: 50, mandatory: true },
        { id: 'carrierCode', maxLength: 50, mandatory: false }, /*Da valutare probabilmente dovrà essere una select con un valore default*/
        { id: 'paymentMethod', maxLength: 50, mandatory: true },
        { id: 'shippingMethod', maxLength: 255, mandatory: true },
        { id: 'shippingAmount', maxLength: 50, pattern: '^\\d+.\\d{ 0,3}$', mandatory: false },
        { id: 'shippingServiceCode', maxLength: 50, mandatory: false },
        { id: 'shippingServiceName', maxLength: 255, mandatory: false },
        { id: 'annotations', maxLength: 4000, mandatory: true },
        { id: 'orderDestination', maxLength: 1, mandatory: false }, /*Valori accettati B -> B2B, C -> B2C*/
        { id: 'DDT_pdf', mandatory: false },
        { id: 'DDT_info', mandatory: false },
        { id: 'scAc', mandatory: false },
        { id: 'shipMethod', mandatory: false },
        { id: 'shippingReferral', mandatory: false },
        { id: 'orderType', maxLength: 50, mandatory: false },
        { id: 'customerSupport', mandatory: false },
        { id: 'labels', mandatory: false },
        /*Order Details (object list)*/
        { id: 'lineNumber', mandatory: true },
        { id: 'SKU', maxLength: 50, mandatory: true },
        { id: 'description', maxLength: 200, mandatory: true },
        { id: 'lot', maxLength: 50, mandatory: false },
        { id: 'quantity', min: 1, mandatory: true },
        { id: 'weight', pattern: '^\\d+.\\d{0, 3}$', mandatory: true },
        { id: 'volume', pattern: '^\\d+.\\d{0,3}$', mandatory: false },
        { id: 'unitPrice', pattern: '^\\d+.\\d{0,3}$', mandatory: true },
        { id: 'originalPrice', pattern: '^\\d+.\\d{0,3}$', mandatory: false },
        { id: 'discount', pattern: '^\\d+.\\d{0,3}$', mandatory: false },
        { id: 'voucher', pattern: '^\\d+.\\d{0,3}$', mandatory: false },
        { id: 'detailsAnnotations', maxLength: 4000, mandatory: false },
        { id: 'lineType', maxLength: 50, mandatory: false }, /*I -> Item, T -> Text*/
        { id: 'CRRefID', mandatory: false },
        { id: 'sucode', mandatory: false },
        { id: 'suquantity', mandatory: false },
        { id: 'orderDate', mandatory: false },
        { id: 'documentDate', mandatory: false },
        { id: 'customerRefNumber', mandatory: false },
        { id: 'customerRefNumber2', mandatory: false },
        { id: 'customerRefNumber3', mandatory: false },
        { id: 'orderPriority', mandatory: false },
        /* Fine Order Details */
        { id: 'outputFormat', maxLength: 1, value: 'P', mandatory: false }, /*Contiene o P o Z attivo solo per alcuni clienti*/
        { id: 'language', value: 'EN', mandatory: false },
        { id: 'GLNshop', maxLength: 50, mandatory: false },
        { id: 'GLNdepot', maxLength: 50, mandatory: false },
        { id: 'customerBillingCode', maxLength: 50, mandatory: false },
        { id: 'pudoPointId', maxLength: 50, mandatory: false },
    ],
    getFieldProp: function (fieldName, fieldProp) {
        let prop = this.Props.find(a => a.id == fieldName.toLowerCase());
        if (prop == undefined) {
            return null;
        }
        if (fieldProp in prop) {
            return prop[fieldProp];
        }

        return '';
    }
}
